import styled from "styled-components";

export const StyledSideElement = styled.div`
  width: 40px;
  position: fixed;
  bottom: 0;
  left: ${(props) => (props.$orientation === "left" ? "40px" : "auto")};
  right: ${(props) => (props.$orientation === "left" ? "auto" : "40px")};
  z-index: 10;
  color: var(--light-slate);
  
  /* Prevent layout shifts - create new stacking context */
  transform: translateZ(0);
  will-change: auto;
  contain: layout style paint;
  backface-visibility: hidden;

  @media (max-width: 1080px) {
    left: ${(props) => (props.$orientation === "left" ? "20px" : "auto")};
    right: ${(props) => (props.$orientation === "left" ? "auto" : "20px")};
  }

  @media (max-width: 768px) {
    display: none;
  }
`;
